<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>账号管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div  slot="header" class="flexContainer">
        <span  class="cardHeader">账号管理</span>
        <el-button style="float:right;" type="primary" size="normal" @click="createClickHandler">添加账号</el-button>
      </div>

      <!-- 搜索条 -->
      <div>
        <el-form :model="queryInfo" :inline="true" size="normal">
          <el-form-item label="关键词：">
            <el-input clearable v-model="queryInfo.query" placeholder="账号或姓名" @clear="getList"></el-input>
          </el-form-item>
          <el-form-item label="角色：">
            <el-select v-model="queryInfo.roleId" placeholder="请选择角色" @change="getList" clearable>
              <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item._id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="员工绑定：">
            <el-select v-model="queryInfo.bindEmployee" placeholder="全部" @change="getList" clearable style="width: 120px">
              <el-option label="已绑定" value="1"></el-option>
              <el-option label="未绑定" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企微绑定：">
            <el-select v-model="queryInfo.bindWecom" placeholder="全部" @change="getList" clearable style="width: 120px">
              <el-option label="已绑定" value="1"></el-option>
              <el-option label="未绑定" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <el-table :data="list" style="margin-top:0px">
        <el-table-column label="编号" type="index" width="60px"></el-table-column>
        <el-table-column label="账号" prop="account" width="130"></el-table-column>
        <el-table-column label="账号使用人" prop="name" width="130"></el-table-column>
        <el-table-column label="等级" prop="level" width="60"></el-table-column>
        <el-table-column label="可用角色" width="200">
          <template slot-scope="scope">
            <template v-for="(item,index) in scope.row.roleIds">
                <el-tag style="margin-right:5px" size="mini" :key="index">{{getRoleName(item)}}</el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="绑定员工" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.bindEmployee" style="font-size: 14px;">
              <div style="font-weight: bold;">{{ scope.row.bindEmployee.name || '未绑定' }}</div>
              <div style="font-size: 12px; color: #909399;">{{ scope.row.bindEmployee.sex }}</div>
            </div>
            <div v-else style="font-size: 14px; color: #909399;">未绑定员工</div>
          </template>
        </el-table-column>
        <el-table-column label="企微账号" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.wecomUserId">{{ scope.row.wecomUserId }}</span>
            <span v-else style="font-size: 14px; color: #909399;">未绑定</span>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" width="160">
          <template slot-scope="scope">
            <el-switch :value="scope.row.status" active-text="启用" inactive-text="禁用" :active-value="1" :inactive-value="0" @change="stateChangeHandler(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="580">
          <template slot-scope="scope">
            <el-button type="primary" plain size="small" @click="modifyClickHandler(scope.row)">修改</el-button>
            <el-button type="primary" plain size="small" @click="deleteClickHandler(scope.row)">删除</el-button>
            <el-button type="primary" plain size="small" @click="bindEmployeeClickHandler(scope.row)" :disabled="scope.row.bindEmployee!==null">绑定员工身份</el-button>
            <el-button type="danger" plain size="small" @click="unbindEmployeeClickHandler(scope.row)" :disabled="!scope.row.bindEmployee">解除员工绑定</el-button>
            <el-button type="primary" plain size="small" @click="bindWecomClickHandler(scope.row)" :disabled="!!scope.row.wecomUserId">绑定企微</el-button>
            <el-button type="danger" plain size="small" @click="unbindWecomClickHandler(scope.row)" :disabled="!scope.row.wecomUserId">解除企微绑定</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10,20,50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 绑定员工对话框 -->
    <el-dialog
      title="绑定员工身份"
      :visible.sync="bindDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="bind-dialog-content">
        <div class="bind-dialog-header">
          <span>账号信息：</span>
          <span>{{ selectedAccount?.account }} - {{ selectedAccount?.name }}</span>
        </div>
        <!-- 员工搜索过滤 -->
        <div class="employee-filter">
          <el-input
            v-model="employeeFilterText"
            placeholder="输入员工姓名进行筛选"
            clearable
            prefix-icon="el-icon-search"
            size="small"
          />
        </div>
        <div class="employee-list">
          <el-empty v-if="filteredEmployeeList.length === 0" description="暂无可绑定的员工"></el-empty>
          <div v-for="employee in filteredEmployeeList" :key="employee._id" class="employee-item">
            <div class="employee-info">
              <div class="employee-details">
                <div class="employee-name">{{ employee.name }}</div>
              </div>
            </div>
            <el-button type="primary" size="small" @click="confirmBind(employee)">绑定</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 绑定企微对话框（从通讯录选择） -->
    <el-dialog
      title="绑定企微账号"
      :visible.sync="wecomDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="bind-dialog-content">
        <div class="bind-dialog-header">
          <span>账号信息：</span>
          <span>{{ wecomBindTarget?.account }} - {{ wecomBindTarget?.name }}</span>
        </div>
        <!-- 通讯录过滤与同步 -->
        <div class="employee-filter wecom-filter">
          <el-input
            v-model="wecomContactFilter"
            placeholder="输入姓名/部门/userid 筛选"
            clearable
            prefix-icon="el-icon-search"
            size="small"
          />
          <el-button size="small" type="primary" plain :loading="wecomSyncLoading" @click="syncWecomContacts">同步通讯录</el-button>
        </div>
        <div class="employee-list">
          <el-empty v-if="filteredWecomContacts.length === 0" description="暂无通讯录数据，请点击「同步通讯录」"></el-empty>
          <div v-for="contact in filteredWecomContacts" :key="contact.userid" class="employee-item">
            <div class="employee-info">
              <div class="employee-details">
                <div class="employee-name">{{ contact.name }}</div>
                <div class="wecom-contact-sub">{{ (contact.departmentNames || []).join(' / ') || '未分配部门' }} · {{ contact.userid }}</div>
              </div>
            </div>
            <el-button type="primary" size="small" @click="confirmBindWecom(contact)">绑定</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wecomDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      queryInfo: {
        query: '',
        roleId: '',
        bindEmployee: '',
        bindWecom: '',
        pagenum: 1,
        pagesize: 10
      },
      total: 0,
      // 绑定员工相关
      bindDialogVisible: false,
      selectedAccount: null,
      employeeList: [],
      employeeFilterText: '', // 员工过滤关键词
      // 绑定企微相关
      wecomDialogVisible: false,
      wecomBindTarget: null,
      wecomContactList: [],
      wecomContactFilter: '',
      wecomSyncLoading: false,
      roleList: []

    }
  },
  created () {
    this.getRoleList()
    this.getList()
  },
  computed: {
    // 过滤后的员工列表
    filteredEmployeeList () {
      if (!this.employeeFilterText) {
        return this.employeeList
      }
      const keyword = this.employeeFilterText.toLowerCase()
      return this.employeeList.filter(employee => {
        return employee.name && employee.name.toLowerCase().includes(keyword)
      })
    },

    // 过滤后的企微通讯录列表（按姓名/部门/userid）
    filteredWecomContacts () {
      if (!this.wecomContactFilter) {
        return this.wecomContactList
      }
      const keyword = this.wecomContactFilter.toLowerCase()
      return this.wecomContactList.filter(contact => {
        return (contact.name && contact.name.toLowerCase().includes(keyword)) ||
          (contact.userid && contact.userid.toLowerCase().includes(keyword)) ||
          (contact.departmentNames || []).some(d => d.toLowerCase().includes(keyword))
      })
    }
  },
  methods: {
    // 获取列表
    async getList () {
      const { data: res } = await this.$http.get('account/list', { params: this.queryInfo })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.list = res.data.list
      this.total = res.data.total
    },

    // 获取角色列表
    async getRoleList () {
      const { data: res } = await this.$http.get('account/getRoleList')
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.roleList = res.data
    },

    // 根据角色ID获取角色名称
    getRoleName (roleId) {
      const role = this.roleList.find(item => item._id === roleId)
      return role ? role.name : '未知角色'
    },

    // 监听pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getList()
    },

    // 监听页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getList()
    },

    // 点击添加按钮
    async createClickHandler () {
      this.$router.push('/account/add')
    },

    // 点击修改按钮
    async modifyClickHandler (row) {
      this.$router.push(`/account/modify/${row._id}`)
    },

    // 修改账号状态
    async stateChangeHandler (row) {
      const { data: res } = await this.$http.put(`account/changeStatus/${row._id}`)
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }
      this.$message.success(res.meta.msg)
      this.getList()
    },

    // 点击删除按钮
    async deleteClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要删除吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      const { data: res } = await this.$http.delete(`account/remove/${row._id}`)

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success(res.meta.msg)
      this.getList()
    },

    // 获取可绑定的员工列表
    async getAvailableEmployeeList () {
      try {
        const { data: res } = await this.$http.get('account/getBindableEmployees')
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return []
        }
        return res.data || []
      } catch (error) {
        this.$message.error('获取员工列表失败')
        console.error('获取员工列表失败:', error)
        return []
      }
    },

    // 绑定员工身份
    async bindEmployeeClickHandler (row) {
      this.selectedAccount = row
      this.employeeFilterText = '' // 清空过滤条件
      this.employeeList = await this.getAvailableEmployeeList()
      this.bindDialogVisible = true
    },

    // 确认绑定
    async confirmBind (employee) {
      try {
        const { data: res } = await this.$http.post('account/bindEmployee', {
          accountId: this.selectedAccount._id,
          employeeId: employee._id
        })

        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }

        this.$message.success('绑定成功')
        this.bindDialogVisible = false
        this.getList() // 刷新列表以更新绑定状态
      } catch (error) {
        console.error('绑定员工失败:', error)
        this.$message.error('绑定失败，请稍后重试')
      }
    },

    // 解除员工绑定
    async unbindEmployeeClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要解绑该账号的员工身份吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)

      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      try {
        const { data: res } = await this.$http.post('account/unbindEmployee', {
          accountId: row._id
        })

        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }

        this.$message.success('解绑成功')
        this.getList() // 刷新列表以更新绑定状态
      } catch (error) {
        console.error('解绑员工失败:', error)
        this.$message.error('解绑失败，请稍后重试')
      }
    },

    // 绑定企微账号（打开通讯录选择弹窗）
    async bindWecomClickHandler (row) {
      this.wecomBindTarget = row
      this.wecomContactFilter = ''
      this.wecomDialogVisible = true
      await this.getWecomContacts()
    },

    // 获取本地通讯录缓存
    async getWecomContacts () {
      try {
        const { data: res } = await this.$http.get('wecom/contact/list')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.wecomContactList = res.data.list || []
      } catch (error) {
        console.error('获取通讯录失败:', error)
        this.$message.error('获取通讯录失败，请稍后重试')
      }
    },

    // 从企微全量同步通讯录到本地缓存
    async syncWecomContacts () {
      this.wecomSyncLoading = true
      try {
        const { data: res } = await this.$http.post('wecom/contact/sync')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.$message.success(res.meta.msg)
        await this.getWecomContacts()
      } catch (error) {
        console.error('同步通讯录失败:', error)
        this.$message.error('同步通讯录失败，请稍后重试')
      } finally {
        this.wecomSyncLoading = false
      }
    },

    // 确认绑定企微（选中通讯录成员；与账号使用人姓名不一致时二次确认防选错）
    async confirmBindWecom (contact) {
      const accountName = (this.wecomBindTarget.name || '').trim()
      const contactName = (contact.name || '').trim()
      if (accountName !== contactName) {
        const confirmResult = await this.$confirm(
          `账号使用人「${accountName}」与所选企微成员「${contactName}」姓名不一致，请核对是否选错人，确定绑定吗？`,
          '姓名不一致提醒',
          {
            confirmButtonText: '确定绑定',
            cancelButtonText: '再检查一下',
            type: 'warning'
          }
        ).catch((err) => err)

        if (confirmResult === 'cancel') return this.$message.info('已取消绑定')
      }

      try {
        const { data: res } = await this.$http.post('account/bindWecom', {
          accountId: this.wecomBindTarget._id,
          wecomUserId: contact.userid
        })

        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }

        this.$message.success(`绑定成功：${contact.name}（${contact.userid}）`)
        this.wecomDialogVisible = false
        this.getList() // 刷新列表以更新绑定状态
      } catch (error) {
        console.error('绑定企微失败:', error)
        this.$message.error('绑定失败，请稍后重试')
      }
    },

    // 解除企微绑定
    async unbindWecomClickHandler (row) {
      const confirmResult = await this.$confirm(
        `确定要解绑该账号的企微账号（${row.wecomUserId}）吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)

      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      try {
        const { data: res } = await this.$http.post('account/unbindWecom', {
          accountId: row._id
        })

        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }

        this.$message.success('解绑成功')
        this.getList() // 刷新列表以更新绑定状态
      } catch (error) {
        console.error('解绑企微失败:', error)
        this.$message.error('解绑失败，请稍后重试')
      }
    }

  }
}
</script>

<style lang="less" scoped>
/* 绑定员工对话框内容区域样式 */
.bind-dialog-content {
  padding: 20px 0;
}

/* 账号信息展示区域样式 */
.account-info {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;

  /* 单个信息项样式 */
  .info-item {
    margin-bottom: 8px;

    /* 最后一个信息项去除底部间距 */
    &:last-child {
      margin-bottom: 0;
    }

    /* 信息标签样式 */
    .label {
      font-weight: bold;
      color: #606266;
      margin-right: 10px;
    }

    /* 信息值样式 */
    .value {
      color: #303133;
    }
  }
}

.bind-dialog-content {
  .bind-dialog-header {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;

    span:first-child {
      font-weight: bold;
      margin-right: 10px;
    }
  }

  /* 员工过滤输入框样式 */
  .employee-filter {
    margin-bottom: 15px;
  }

/* 员工列表容器样式 */
.employee-list {
  max-height: 300px; /* 最大高度，超出时显示滚动条 */
  overflow-y: auto; /* 垂直滚动 */

  /* 单个员工项样式 */
  .employee-item {
    display: flex;
    justify-content: space-between; /* 两端对齐 */
    align-items: center; /* 垂直居中对齐 */
    padding: 12px 15px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-bottom: 10px;
    background-color: #fff;

    /* 悬停效果 */
    &:hover {
      background-color: #f5f7fa;
    }

    /* 员工信息区域样式 */
    .employee-info {
      flex: 1; /* 占据剩余空间 */

      /* 员工姓名样式 */
      .name {
        font-weight: bold;
        color: #303133;
        margin-bottom: 4px;
      }

      /* 员工详细信息样式 */
      .details {
        font-size: 12px;
        color: #909399;

        /* 详细信息项间距 */
        span {
          margin-right: 15px;

          /* 最后一个详细信息项去除右侧间距 */
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    /* 绑定按钮样式 */
    .bind-btn {
      margin-left: 15px;
    }
  }

  /* 空状态提示样式 */
  .empty-state {
    text-align: center;
    padding: 40px 0;
    color: #909399;

    /* 空状态图标样式 */
    i {
      font-size: 48px;
      margin-bottom: 10px;
      color: #c0c4cc;
    }

    /* 空状态文字样式 */
    .empty-text {
      font-size: 14px;
    }
  }
}
}

/* 企微通讯录过滤行（筛选框 + 同步按钮并排） */
.wecom-filter {
  display: flex;
  align-items: center;

  .el-input {
    flex: 1;
    margin-right: 8px;
  }
}

/* 通讯录成员副信息（部门 · userid） */
.wecom-contact-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* 对话框底部按钮区域样式 */
.dialog-footer {
  text-align: right;
  padding-top: 10px;
}
</style>
